import Page from 'modules/Page';
import lazyWithSuspense from 'modules/lazyWithSuspense';
import makePage from 'modules/makePage';
import { i18n } from 'i18n';
import * as parentConstants from 'modules/project-admin/ProjectDetailsPage/constants';
import { toTitleCase } from 'utils';
import * as constants from './constants';
import { EditProjectPageParams } from './constants';
import useEditProjectQueries, { EditProjectQueries } from './useEditProjectQueries';

const EditProjectPage = lazyWithSuspense(() => import('./EditProjectPage'));

const page: Page = {
  title: constants.TITLE,
  routeProps: {
    path: constants.ROUTE_PATH,
  },
  admin: true,
  component: makePage<EditProjectPageParams, EditProjectQueries>({
    WrappedPage: EditProjectPage,
    titleFn: ([project]) => (project.data ? i18n._('Edit').concat(` ${toTitleCase(project.data.name)}`) : ''),
    parentPathTemplate: parentConstants.ROUTE_PATH,
    parentTitleFn: () => i18n._(parentConstants.TITLE),
    pageDataHook: useEditProjectQueries,
  }),
};

export default page;
